module.exports = __webpack_public_path__ + "img/1512819925.5fda5a74.jpg";